import { render, staticRenderFns } from "./createNewProductDialog.vue?vue&type=template&id=dad79e72"
import script from "./createNewProductDialog.vue?vue&type=script&lang=js"
export * from "./createNewProductDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports